






































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { AdmiralError, IComment, PolicyModel, PolicyStatus } from 'admiral-core';
import { ArrowLeftIcon, ArrowRightIcon, PlusIcon, XIcon } from 'vue-feather-icons';
import { mixins } from 'vue-class-component';
import { BaseMixin } from '@/mixins/BaseMixin';
import { PolicyApi } from '@/services/PolicyApi';
import TaskOverview from '@/views/pages/tasks/TaskOverview.vue';
import '@/assets/scss/pages/app-todo.scss';
import { BModal } from 'bootstrap-vue';
import PolicyForm from '@/forms/PolicyForm.vue';
import { FormMixin } from '@/mixins/FormMixin';
import FormSubmit from '@/components/common/forms/FormSubmit.vue';
import FormInput from '@/components/common/forms/FormInput.vue';
import { Util } from '@/utils/Util';

@Component({
  components: {
    FormSubmit,
    PolicyForm,
    ArrowLeftIcon,
    ArrowRightIcon,
    PlusIcon,
    TaskOverview,
    XIcon,
  },
})
export default class CreatePolicyModal extends mixins(FormMixin, BaseMixin) {
  @Prop({ type: Boolean, default: false })
  fromPolicy!: boolean;

  model = this.defaultModel();
  isLoading2 = false;
  isDone2 = false;

  defaultModel(): PolicyModel {
    return {
      user: this.user,
      customer: '',
      product: undefined,
      value: '',
      businessYear: new Date(),
      quantity: '',
      relativeValue: 0,
      probability: 4,
      status: PolicyStatus.OPEN,
      tags: [],
      tasks: [],
      type: 'new',
      policySteps: [],
      notes: '',
      newUploadedFiles: [],
      files: [],
      newComments: [],
    };
  }

  async mounted() {
    this.model.user = this.user;
    // focus "customer"
    (this.$refs['create-policy'] as BModal).$on('shown', () => {
      (
        ((this.$refs['policyform'] as PolicyForm).$refs['customer'] as FormInput)
          .$el as HTMLInputElement
      ).focus();
    });
  }

  @Watch('model', { immediate: true })
  watchModel() {
    if (
      this.model.user &&
      this.model.customer &&
      this.model.product &&
      this.model.value &&
      this.model.quantity
    ) {
      this.$root.$emit('complete-required-create-policy');
    }
  }

  createAntragsbuchData() {
    if (this.model.status === PolicyStatus.POLICED && !this.model.antragsbuchData) {
      this.model.antragsbuchData = {
        submittedAt: new Date(),
        isArchived: false,
        policyStartAt: new Date(),
        policyEndAt: new Date(),
        bonus: 0,
        vnr: '',
      };
    }
  }

  /** Übernimmt einen noch nicht abgesendeten Kommentar aus dem Eingabefeld. */
  appendPendingComment(policyForm: PolicyForm) {
    const commentbox = policyForm.$refs['commentbox'] as any;
    if (!commentbox?.value?.text?.trim()) {
      return;
    }
    const newComments = [...(this.model.newComments || [])];
    newComments.push({
      id: 'new-comment-' + newComments.length,
      text: commentbox.value.text,
      createdAt: new Date(),
      updatedAt: new Date(),
      user: this.user!,
      isDemo: false,
    });
    this.model.newComments = newComments;
    commentbox.resetComment();
  }

  async okMore() {
    try {
      this.isLoading = true;
      this.resetErrors();

      const policyForm = this.$refs['policyform'] as PolicyForm;
      this.appendPendingComment(policyForm);
      await PolicyApi.create({
        agency: this.agency,
        user: this.model.user!,
        customer: this.model.customer,
        product: this.model.product,
        value: Number(this.model.value),
        businessYear: this.model.businessYear ? this.model.businessYear : new Date(),
        relativeValue: Number(this.model.relativeValue),
        quantity: Number(this.model.quantity),
        status: this.model.status,
        probability: this.model.probability,
        jahresNettoBeitrag: Number(this.model.jahresNettoBeitrag),
        tags: this.model.tags,
        tasks: this.model.tasks,
        type: this.model.type,
        notes: this.model.notes,
        antragsbuchData: this.model.antragsbuchData,
        declinedReason: this.model.declinedReason,
        newUploadedFiles: this.model.newUploadedFiles,
        newComments: Util.sanitizeNewCommentsForApi(this.model.newComments || []),
      });

      this.model = {
        ...this.model,
        product: undefined,
        value: '',
        quantity: '',
        tags: [],
        tasks: [],
        files: [],
        newUploadedFiles: [],
        newComments: [],
      };

      this.$toastr.s(
        `Vertrag für ${this.model.customer} erfolgreich angelegt.`,
        'Vertrag angelegt',
      );

      this.$emit('reload');
    } catch (e) {
      const apiErrors = this.exceptionErrors(e);
      this.errorHandling(apiErrors);

      this.$toastr.e('Beim Speichern der Anbahnung ist etwas schief gelaufen.', 'Ooops');
    } finally {
      this.isLoading = false;
    }
  }

  async ok(evt: Event) {
    evt.preventDefault();
    try {
      this.isLoading2 = true;
      // await Util.wait(150);
      this.resetErrors();
      const policyForm = this.$refs['policyform'] as PolicyForm;
      this.appendPendingComment(policyForm);

      await PolicyApi.create({
        agency: this.agency,
        user: this.model.user!,
        customer: this.model.customer,
        product: this.model.product,
        value: Number(this.model.value),
        businessYear: this.model.businessYear ? this.model.businessYear : new Date(),
        relativeValue: Number(this.model.relativeValue),
        quantity: Number(this.model.quantity),
        status: this.model.status,
        probability: this.model.probability,
        jahresNettoBeitrag: Number(this.model.jahresNettoBeitrag),
        tags: this.model.tags,
        tasks: this.model.tasks,
        type: this.model.type,
        notes: this.model.notes,
        antragsbuchData: this.model.antragsbuchData,
        declinedReason: this.model.declinedReason,
        newUploadedFiles: this.model.newUploadedFiles,
        newComments: Util.sanitizeNewCommentsForApi(this.model.newComments || []),
      });
      this.$nextTick(() => {
        (this.$refs['create-policy'] as BModal).hide('submitted');
        this.$toastr.s(
          `Vertrag für ${this.model.customer} erfolgreich angelegt.`,
          'Vertrag angelegt',
        );
        this.$emit('reload');
        this.$emit('submitted');
        this.model = { ...this.defaultModel() };
      });
    } catch (e) {
      const apiErrors = this.exceptionErrors(e);

      this.errorHandling(apiErrors);
      this.$toastr.e('Beim Speichern des Vertrags ist etwas schief gelaufen.', 'Oops');
    } finally {
      this.isLoading2 = false;
    }
  }

  errorHandling(apiErrors: Record<string, string>) {
    this.addError(apiErrors['productisNotEmpty'], 'product', 'Bitte ein Produkt auswählen.');
    this.addError(
      apiErrors['customerisNotEmpty'] || apiErrors['customerminLength'],
      'customer',
      'Bitte einen gültigen Kundennamen wählen.',
    );

    this.addError(
      apiErrors['valueisNumber'] || apiErrors['valuemin'] || apiErrors['valueisNotEmpty'],
      'value',
      (this.agency.wording?.value || 'Bewertung') + ' >= 1',
    );

    this.addError(
      apiErrors['quantityisNumber'] || apiErrors['quantitymin'] || apiErrors['quantityisNotEmpty'],
      'quantity',
      'Stückzahl >= 0',
    );

    this.addError(
      apiErrors[AdmiralError.Existing],
      'general',
      'Es existiert bereits eine Anbahnungen mit den eingetragenen Daten.',
    );
  }

  cancel() {
    this.model = this.defaultModel();
  }

  reload() {
    //
  }
}
